import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../../../types/user.model';

import { TranslateModule } from '@ngx-translate/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';

@Component({
  selector: 'ganarbol-list',
  standalone: true,
  imports: [TranslateModule, NzAvatarModule],
  templateUrl: './ganarbol-list.component.html',
  styleUrl: './ganarbol-list.component.scss'
})
export class GanarbolListComponent {
  @Input() public ganarbols: User[];
  @Output() public ganarbolClick: EventEmitter<number>;

  constructor() {
    this.ganarbolClick = new EventEmitter<number>();
  }

  public onGanarbolClick(ganarbol: User): void {
    this.ganarbolClick.emit(ganarbol.id);
  }
}
